import { CollideEvent, CollideId } from '../../defs/collide';
import {
  ButterflyBlockEntity,
  despawnBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { ButterflyEffect } from '../effects/ButterflyEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

/*
    butterfly block collision resolver
*/
export class ButterflyCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _entity: ButterflyBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
    block: this._resolveBlock,
    attack: this._resolveAttack,
  };

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, entity: ButterflyBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  // impl
  //-------------------------------------------------------------------------
  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveTap() {
    await new InvalidEffect(this._entity).execute();
    return false;
  }

  private async _resolveBlock() {
    await this._attack();
    return true;
  }

  private async _resolveAttack() {
    await this._attack();
    return true;
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _attack() {
    this._entity.c.blockButterfly.view.stopAnimation();
    const butterfly = this._entity.c.blockButterfly.view.sprite;
    const position = this._entity.c.position.mapPosition;
    despawnBlockEntity(this._scene, this._entity);
    await new ButterflyEffect(this._scene, {
      position,
      scale: butterfly.scaleX,
      rotation: butterfly.rotation,
    }).execute();
  }
}
